const autocompletes = document.querySelectorAll('.js-specialist-search');

/**
 *
 *
 *
 */
const init = function() {

  if ( autocompletes ) {
	  setupAutocomplete();
  }

};


/**
 *
 *
 *
 */
const setupAutocomplete = function() {
    
  autocompletes.forEach( ( element ) => {

    const form = element.querySelector('form');
    const button = element.querySelector( 'button' );
    const selectMenu = element.querySelector( 'select' );
    const selectOptions = selectMenu.querySelectorAll('option');
    const textInput = element.querySelector( 'input[type="text"]' );
    const hiddenInput = element.querySelector( 'input[type="hidden"]' );

    element.classList.add('is-initialized');

    form.addEventListener( 'submit', (ev) => {
      ev.preventDefault();
      doSearch();
    } )

    /**
     * 
     */
    const doSearch = function() {

      console.log('Doing search...');

      // reset search if there is no value in the search field
      if ( textInput.value.trim() === '' ) {
        
        console.log('Criteria empty. Reset search.');
        resetSearch( element );

      // otherwise, update the UI based on the search criteria
      } else {
        
        hiddenInput.value = '';

        console.log( 'textInput: ' + textInput.value );
        console.log( 'hiddenInput: ' + hiddenInput.value );

        selectOptions.forEach( (option) => {
          if ( textInput.value === option.label ) {
            hiddenInput.value = option.value;
          }
        } );

        udpateSearchUI( element, hiddenInput.value );

      }
        
    }

    /**
     * 
     */
    // textInput.addEventListener( 'keydown', ( event ) => {
    //   if ( event.code === 'Enter' ) {
    //     doSearch();
    //   }
    // });

    /**
     * 
     */
    textInput.addEventListener( 'awesomplete-selectcomplete', function(e) {
      textInput.value = e.text.label;
      hiddenInput.value = e.text.value;
      udpateSearchUI( element, e.text.value );
    }, false);

    /**
     * 
     */
    button.addEventListener( 'click', () => {
      doSearch();
    } );

  } );

}


/**
 * 
 * 
 * 
 */
const udpateSearchUI = function( search, termID ) {
  
  let hasResults = false;
  const specialists = search.querySelectorAll('.js-specialist');

  search.classList.remove('has-no-results');
  search.classList.add('is-searching');

  if ( specialists ) {

    specialists.forEach( ( specialist ) => {
      specialist.style.display = 'none';

      const hospitals = JSON.parse( specialist.getAttribute('data-hospitals') );

      if ( hospitals.includes( parseInt( termID ) ) ) {
        specialist.style.display = 'block';
        hasResults = true;
      }
    } );

    setTimeout( () => {  
      search.classList.remove('is-searching');

      if ( !hasResults ) {
        search.classList.add('has-no-results');
      }
    }, 1200 );

  }

}


/**
 * 
 * 
 * 
 */
const resetSearch = function( search ) {
  
  const specialists = search.querySelectorAll('.js-specialist');
  
  search.classList.remove('has-no-results');
  search.classList.remove('is-searching');

  specialists.forEach( ( specialist ) => {
    specialist.style.display = 'block';
  } );

}


/**
 * 
 * 
 * 
 */
const api = {
	init: init
};

export default api;